<canvas #toolCanvas class="cm-tool-canvas" resize (contextmenu)="(false)"></canvas>
<canvas #mainCanvas class="cm-main-canvas" resize (contextmenu)="(false)"></canvas>
<ng-content></ng-content>
